import i18next from 'i18next';
import { NAMESPACES } from '~/i18n/namespaces';
import {
    AsAllowed,
    AsDisabled,
    LimitationProps
} from '~/components/Builder/Common/CreationLimitations/creationLimitations.types';
import invariant from 'ts-invariant';
import { hasServerFormatSmartFields } from '~/common/SmartFields/smart-fields.utils';

export const forbidSmartFieldsInPublicFlows = ({
    sourceBlock,
    targetFlow
}: LimitationProps<'targetFlow' | 'sourceBlock'>) => {
    invariant(!!sourceBlock, 'a block must be provided');
    invariant(
        sourceBlock.type === 'text_block',
        'expected the provided block to be a text block'
    );

    if (
        targetFlow.isLeadForm &&
        hasServerFormatSmartFields(sourceBlock.content)
    ) {
        const t = i18next.getFixedT(
            null,
            NAMESPACES.BUILDER,
            'creation_limitation_dialog'
        );

        return AsDisabled(t('text_block_contains_smart_fields'));
    }

    return AsAllowed;
};
